(() => {
 const config = document.getElementById('astrosage-optional-apps');
 if (!config) return;
 let started = false;
 const events = ['pointerdown','keydown','scroll'];
 function start() {
  if (started) return;
  started = true;
  events.forEach(event => window.removeEventListener(event,start));

  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i + "?ref=shopify";
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);

    c.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], error => {
      if (error) {
        console.error("Error loading Shopify features:", error);
        return;
      }

      c[a]('consentv2', {
        ad_Storage: c.Shopify.customerPrivacy.marketingAllowed() ? "granted" : "denied",
        analytics_Storage: c.Shopify.customerPrivacy.analyticsProcessingAllowed() ? "granted" : "denied",
        source: 101,
      });
    });

    l.addEventListener("visitorConsentCollected", function (e) {
      c[a]('consentv2', {
        ad_Storage: e.detail.marketingAllowed ? "granted" : "denied",
        analytics_Storage: e.detail.analyticsAllowed ? "granted" : "denied",
        source: 101,
      });
    });
  })(window, document, "clarity", "script", "umrqe0kydw");


  (function(d){
      var s = d.createElement('script');
      s.async = true;
      s.src = "https://adsagentclientafd-b7hqhjdrf3fpeqh2.b01.azurefd.net/frontendInjection.js";
      var firstScript = d.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(s, firstScript);
  })(document);

  if (!document.querySelector('script[src="https://widgets.goaffpro.app/main.js"]')) {
   const widget = document.createElement('script'); widget.type='module';
   widget.src='https://widgets.goaffpro.app/main.js'; document.head.appendChild(widget);
  }
 }
 if (config.dataset.defer === 'true') events.forEach(event => window.addEventListener(event,start,{once:true,passive:true}));
 else start();
})();
